<mat-card>
  <mat-card-content>
    <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="space-between center">
      <img
        src="{{ serviceProfileURL$ | async }}"
        mat-card-avatar
        ngClass.xs="avatar-xs"
        class="card-image"
      />
      <div fxFlex="80" class="title-container">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          fxLayout.gt-xs="row"
          fxLayoutAlign.gt-xs="space-between center"
        >
          <p class="title">{{ (serviceProvider$ | async)?.title }}</p>
          <span class="time-recieved"
            ><strong fxHide fxShow.gt-xs>Recieved:</strong>
            {{ lastMessageTimeFormatted$ | async }}</span
          >
        </div>
        <p
          fxHide
          fxShow.gt-xs
          title="{{ (lastMessage$ | async)?.message }}"
          class="sub-title last-message"
        >
          {{ (lastMessage$ | async)?.message }}
        </p>
      </div>
      <button
        routerLink="{{ contact.serviceKey }}/{{ contact.clientUserKey }}"
        mat-raised-button
        color="primary"
      >
        Read
      </button>
    </div>
    <p
      fxShow
      fxHide.gt-xs
      title="{{ (lastMessage$ | async)?.message }}"
      class="sub-title last-message"
    >
      {{ (lastMessage$ | async)?.message }}
    </p>
  </mat-card-content>
</mat-card>
